import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, ArrowRight, Loader2 } from "lucide-react";
import { submitContact } from "../lib/api";

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Inserisci un'email valida");
      return;
    }
    setLoading(true);
    try {
      await submitContact({
        type: "newsletter",
        nome: "Newsletter",
        cognome: "Subscriber",
        email,
        telefono: "-",
        residenza: "-",
        universita: "pegaso",
        corso: "Newsletter / Lead Magnet",
        messaggio: "Iscrizione newsletter dal sito - richiesta guida gratuita",
        gdpr_consent: true,
      });
      setDone(true);
      setEmail("");
      toast.success("Email registrata! Riceverai la guida a breve.");
    } catch (err) {
      toast.error("Errore. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-16 bg-brand-cream relative overflow-hidden" data-testid="newsletter-section">
      <div className="absolute inset-0 dot-pattern opacity-[0.06]" />
      <div className="absolute -top-32 left-1/4 w-96 h-96 rounded-full bg-brand-emerald/10 blur-3xl" />
      <div className="absolute -bottom-32 right-1/4 w-96 h-96 rounded-full bg-brand-gold/10 blur-3xl" />

      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-brand-line text-[12px] font-semibold mb-5">
          <Mail className="w-3.5 h-3.5 text-brand-emerald" /> Guida gratuita
        </div>
        <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-tight text-brand-navy">
          Scarica la <span className="text-brand-emerald">guida completa</span><br />
          alle 3 università telematiche.
        </h2>
        <p className="mt-5 text-brand-muted text-lg max-w-2xl mx-auto">
          Tutti i corsi, costi reali e convenzioni Pegaso, Mercatorum, San Raffaele in un PDF di 24 pagine. Inviato subito via email.
        </p>

        {done ? (
          <div className="mt-8 inline-flex items-center gap-3 px-6 py-4 rounded-2xl bg-brand-emerald/10 border border-brand-emerald/30" data-testid="newsletter-success">
            <div className="w-2 h-2 rounded-full bg-brand-emerald animate-pulse" />
            <span className="text-brand-emerald font-semibold">Email registrata. Controlla la posta!</span>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 max-w-lg mx-auto flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
            <input
              type="email"
              required
              placeholder="La tua email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 h-14 px-5 rounded-full bg-white border border-brand-line text-brand-ink placeholder:text-brand-muted focus:outline-none focus:ring-2 focus:ring-brand-emerald transition-all"
              data-testid="newsletter-email"
            />
            <button
              type="submit"
              disabled={loading}
              className="btn-primary h-14 px-7 disabled:opacity-60 whitespace-nowrap"
              data-testid="newsletter-submit"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />}
              Scarica gratis
            </button>
          </form>
        )}

        <p className="mt-4 text-xs text-brand-muted">
          Nessuno spam. Una guida + 2 email/mese al massimo. Cancellazione con un click.
        </p>
      </div>
    </section>
  );
}
